import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="company"
export default class extends Controller {
  static targets = ["storeBusiness", "radio", "isStoreBusiness"];
  declare readonly storeBusinessTarget: HTMLElement;
  declare readonly radioTargets: HTMLInputElement[];
  declare readonly isStoreBusinessTarget: HTMLInputElement;

  connect() {
    this.toggleStoreBusiness(); // 初期表示
  }

  toggleStoreBusiness() {
    const selected = this.radioTargets.find((radio) => radio.checked);
    const isIndividual = selected?.value === "false"; // 個人事業主の場合

    if (isIndividual) {
      this.storeBusinessTarget.style.display = "block";
    } else {
      this.resetStoreBusinessCheck();
      this.storeBusinessTarget.style.display = "none";
    }
  }

  resetStoreBusinessCheck() {
    this.isStoreBusinessTarget.checked = false;
  }
}
